import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Upload, Loader2, Palette } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const StyleRow = ({ style, uploading, onUpload }) => (
  <div className="border border-slate-200 rounded-xl p-3" data-testid={`video-style-row-${style.key}`}>
    <div className="flex items-center justify-between mb-2">
      <p className="font-semibold text-sm text-slate-800">{style.label}</p>
      <span className={`text-[10px] px-2 py-0.5 rounded-full font-medium ${style.configured ? 'bg-green-100 text-green-700' : 'bg-slate-100 text-slate-500'}`}
        data-testid={`video-style-status-${style.key}`}>
        {style.configured ? 'Prêt' : 'Aucune vidéo modèle'}
      </span>
    </div>
    {style.sample_url && (
      <video src={style.sample_url} controls muted playsInline className="w-full aspect-video rounded-lg bg-black mb-2" data-testid={`video-style-sample-${style.key}`} />
    )}
    <label className="inline-flex items-center gap-2 text-xs font-medium text-purple-700 cursor-pointer hover:underline" data-testid={`video-style-upload-${style.key}`}>
      {uploading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />}
      {uploading ? 'Envoi à PixVerse…' : style.configured ? 'Remplacer la vidéo modèle' : 'Ajouter une vidéo modèle'}
      <input type="file" accept="video/mp4,video/quicktime,video/webm" className="hidden" disabled={uploading}
        onChange={(e) => { const f = e.target.files?.[0]; e.target.value = ''; if (f) onUpload(style.key, f); }} />
    </label>
  </div>
);

export const VideoStylesManager = ({ open, onOpenChange, styles, getAuthHeader, onChanged }) => {
  const [uploading, setUploading] = useState(null);

  const onUpload = async (key, file) => {
    setUploading(key);
    try {
      const fd = new FormData();
      fd.append('file', file);
      await axios.post(`${API}/admin/video-styles/${key}/sample`, fd, { headers: getAuthHeader(), timeout: 180000 });
      toast.success('Vidéo modèle enregistrée');
      onChanged?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Échec de l'envoi");
    } finally {
      setUploading(null);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto" data-testid="video-styles-manager">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Palette className="h-5 w-5 text-purple-600" /> Styles vidéo</DialogTitle>
          <DialogDescription>Chaque style copie sa vidéo modèle (plans, décor, mouvements) avec la photo du véhicule.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          {styles.map(s => <StyleRow key={s.key} style={s} uploading={uploading === s.key} onUpload={onUpload} />)}
        </div>
      </DialogContent>
    </Dialog>
  );
};
